import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../../../../config/farmDetails";
import { harvestYearDetail } from "../../../../../../config/harvestYearDetail";
import { updateLoadIndicatorAction } from "../../../../../../modules/loadnoindicator/action";
import "../../../../../../style";
import { validForm } from "../../../../../FormElement/FormValidator";
import LoadIndicatorForm from "./LoadIndicatorForm";

const history = createBrowserHistory();

class EditLoadNoIndicator extends Component {
  state = {
    loadInfo: {
      fieldGroupId: localStorage.getItem("currentFieldGrpId"),
      type: "",
      code: "",
      harvestYear: harvestYearDetail().name,
      farmId: userFarmDetail().id || this.props.selectedMainFarm
    },
    formErrors: {
      type: "",
      code: ""
    },
    isValid: true,
    successMessage: "",
    errorMessage: {},
    edited: false
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  componentWillMount() {
    const { id, type, code } = this.props.selectedLoad;
    this.setState({
      loadInfo: {
        fieldGroupId: localStorage.getItem("currentFieldGrpId"),
        id,
        type,
        code
      }
    });
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "code" || name === "type") {
      if (value.match(/^(\w|\ |\-){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          loadInfo: {
            ...prevState.loadInfo,
            [name]: value
          }
        };
      },
      () => {
        const { loadInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, loadInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.loadUpdated && nextProps.loadUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  updateLoadIndicator = e => {
    e.preventDefault();
    const { loadInfo, isValid } = this.state;
    loadInfo.harvestYear = harvestYearDetail().name;
    loadInfo.farmId = userFarmDetail().id || this.props.selectedMainFarm;
    this.setState({ isValid: true, edited: false });

    this.props.updateLoadIndicatorAction(loadInfo);
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  render() {
    const { successMessage, loadInfo, isValid, edited } = this.state;
    if (successMessage) {
      return (
        <Redirect to="/farmsetup/farminformation/field-groups/indicators" />
      );
    }
    return (
      <LoadIndicatorForm
        buttonLabel="Update"
        formLabel="Edit load indicator"
        loadInfo={loadInfo}
        handleChange={this.handleChange}
        //handleError={this.handleError}
        createLoadIndicator={this.updateLoadIndicator}
        isValid={isValid}
        onCancel={this.onCancel}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedLoad: state.loadReducer.selectedLoad,
    loadUpdated: state.loadReducer.loadUpdated,
    selectedMainFarm: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateLoadIndicatorAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditLoadNoIndicator);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/LoadNumberIndicators/EditLoadNoIndicator.js